module.exports = __webpack_public_path__ + "static/media/train5.ca36bbfc.svg";